import {connect} from 'react-redux';
import React from 'react';

import HasCommunity from '../../validate/HasCommunity';
import HasData from '../../validate/HasData';
import LoadCommunity from '../../loaders/LoadCommunity';
import LoadSubEvent from '../../loaders/LoadSubEvent';
import SubEvent from './SubEvent/SubEvent';
import WaitWhileBusy from '../../WaitWhileBusy';

const ConnectedScreen = connect((state, props) => {
    let community = state.events[props.communityId].event;
    return {
        community,
        event: _.find(community.subevents, event => event.id == props.eventId),
        notifications: _.chain(state.events[props.eventId])
            .get('notifications.eventMessage', [])
            .filter(notif => _.get(notif, 'content.data.target', '').split('/')[0] == 'events')
            .filter(notif => _.get(notif, 'content.data.target', '').split('/')[1] == props.eventId)
            .reject(notif => notif.read)
            .value(),
    };
})(SubEvent);

export default props => (
    <LoadCommunity eventId={props.match.params.communityId}>
        <WaitWhileBusy>
            <HasCommunity eventId={props.match.params.communityId}>
                <LoadSubEvent communityId={props.match.params.communityId} eventId={props.match.params.eventId}>
                    <WaitWhileBusy>
                        <HasData
                            check={state => state.events[props.match.params.communityId].event?.subevents?.find(e => e.id == props.match.params.eventId)}
                            warningMessage={`Unable to find subEvent ${props.match.params.eventId} inside community ${props.match.params.communityId}`}
                            to="/">
                            <ConnectedScreen {...props.match.params} />
                        </HasData>
                    </WaitWhileBusy>
                </LoadSubEvent>
            </HasCommunity>
        </WaitWhileBusy>
    </LoadCommunity>
);
